var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm3 4c-1.656 0-3 1.512-3 3.375V8.5H5.333C4.598 8.5 4 9.173 4 10v4.5c0 .827.598 1.5 1.333 1.5H12c.735 0 1.333-.673 1.333-1.5V10c0-.827-.598-1.5-1.333-1.5h-.667V7.375c0-1.036.746-1.875 1.667-1.875.92 0 1.667.84 1.667 1.875V8.5c0 .415.298.75.666.75.37 0 .667-.335.667-.75V7.375C16 5.512 14.656 4 13 4z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.6dd6a32313cd613e714719e6e05e5a6a.svg";
export { ForwardRef as ReactComponent };